/**
 * Created by Pradeep Kumar on 7/03/2019.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {TombOfNefertitiGameShaker} from "../../gameshake/TombOfNefertitiGameShaker";
import {TombOfNefertitiReelController} from "../../reel/reel/TombOfNefertitiReelController";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";

export class TombOfNefertitiRandomCursePresentationView extends BaseView {

    private _fire:TimelineSprite;
    private _fireEnd:TimelineSprite[] = [];

    private _bgOverlay:PIXI.Graphics;
    private _nefertiti:PIXI.Sprite;

    private _gameConfigInstance:TombOfNefertitiGameConfig = TombOfNefertitiGameConfig.instance;
    private _layer:PIXI.Container;

    private _tl:TimelineLite | null = null;
    private _endTl:TimelineLite | null = null;

    private _curseSymbol:string = "";

    private _isNefertitiShown:boolean = false;

    private _endPlayed:boolean = false;

    set curseSymbol(value:string) {
        this._curseSymbol = value;

        this._endPlayed = false;
    }

    public playAnim(mode:string):void {
        this._tl = new TimelineLite();

        let speedScaleFactor:number = 1;
        if(GameSetting.isFastSpin) {
            speedScaleFactor = 4;
        }

        const alphaDur:number = 0.5 / speedScaleFactor,
            timeToStartAlphaOff:number = 1.5 / speedScaleFactor,
            startDelay:number = (mode === GameMode.NORMAL) ? 1 / speedScaleFactor : -1 / speedScaleFactor;

        if(mode === GameMode.NORMAL) {
            this._tl.add(() => {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.NEFERTITI_TRIGGER);
                this._bgOverlay.visible = true;

                this._isNefertitiShown = true;

                TweenLite.to(this._nefertiti, alphaDur, {
                    alpha : 1
                });
            }, startDelay);

            this._tl.add(() => {
                this._bgOverlay.visible = false;

                TweenLite.to(this._nefertiti, alphaDur, {
                    alpha : 0
                });
            }, timeToStartAlphaOff + startDelay);
        }

        this._tl.add(() => {
            this.setFiretoFrame(true);
        }, timeToStartAlphaOff + alphaDur + startDelay);

        this._tl.play();
    }

    public killTimeLine(calledFromAbort:boolean = false):void {
        const duration:number = 0.5;

        if(this._tl) {
            this._tl!.kill();
            this._tl = null;
        }
        if(this._endTl) {
            this._endTl!.kill();
            this._endTl = null;
        }

        SlotGame.sound.stopEffect(TombOfNefertitiSoundConfig.instance.NEFERTITI_FLAME_LOOP);

        if(this._fire.alpha > 0 && !this._endPlayed) {
            TweenLite.to(this._fire, duration, {
                alpha : 0
            });

            this._endPlayed = true;

            SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.NEFERTITI_FLAME_EXTINGUISH);
            for(let i:number = 0; i < this._fireEnd.length; ++i) {
                this._fireEnd[i].getAnimationAutoShowHide(true, true);
            }
        }

        this._bgOverlay.visible = false;

        if(calledFromAbort) {
            if(this._fire.alpha === 0) {
                EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.START_GAME_SHAKING_REEL_AREA_FS_MODE));
                TweenLite.to(() => {}, 0.5, {
                    onComplete : () => {
                        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.STOP_GAME_SHAKING));
                    }
                });
            }

            if(!this._isNefertitiShown) {
                TweenLite.to(this._nefertiti, 0.2, {
                    alpha : 1,
                    onComplete : () => {
                        TweenLite.to(this._nefertiti, 0.2, {
                            alpha : 0
                        });
                    }
                });

                this._isNefertitiShown = false;
                return;
            }
        }

        this._isNefertitiShown = false;
        TweenLite.to(this._nefertiti, duration, {
            alpha : 0
        });
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(this._gameConfigInstance.LAYERS.CURSE_FEATURE.name);

        this.createNefertiti();

        const offsetY:number = 3,
            numOfExtinguishFire:number = 5;

        let fireEnd:TimelineSprite;

        this._fire = new TimelineSprite(GameResources.getTextures("fireOneCycle"));
        this._fire.blendMode = PIXI.BLEND_MODES.ADD;
        this._fire.anchor.set(0.5);
        this._fire.scale.set(2);
        this._fire.position.set(this._gameConfigInstance.GAME_WIDTH / 2, this._gameConfigInstance.GAME_HEIGHT / 2 - ((this._gameConfigInstance.GAME_HEIGHT - this._fire.height) / 2) + offsetY);
        this._fire.visible = false;
        this._fire.alpha = 0;

        this._layer.addChild(this._fire);

        for(let i:number = 0; i < numOfExtinguishFire; ++i) {
            fireEnd = new TimelineSprite(GameResources.getTextures("fireExtinguish"), 60);
            fireEnd.blendMode = PIXI.BLEND_MODES.ADD;
            fireEnd.anchor.set(0.5);
            fireEnd.scale.set(4);
            fireEnd.position.set(this._gameConfigInstance.GAME_WIDTH / 2, this._gameConfigInstance.GAME_HEIGHT / 2 - ((this._gameConfigInstance.GAME_HEIGHT - this._fire.height) / 2) + offsetY);
            fireEnd.visible = false;
            this._layer.addChild(fireEnd);

            this._fireEnd.push(fireEnd);
        }
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinReelEvent.REEL_STOP_SPIN_BOUNCE_STARTED, (event:GameEvent) => this.stopFire((event.params[0])));
        EventHandler.addEventListener(this, "syncReelsOnSpinStart", () => this.syncReelsOnSpinStart());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, () => this.killTimeLine(false));
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize && super.onResize(resizeData);

        const stageCenter:number[] = Helper.getSymbolPositions(Math.floor(TombOfNefertitiGameConfig.instance.REELS_NUM / 2), 0),
            portraitOffset:number = 10,
            landscapeOffset:number = 65;

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._nefertiti.scale.set(0.75);
            this._nefertiti.position.set(stageCenter[0], stageCenter[1] + portraitOffset);
        } else {
            this._nefertiti.scale.set(1);
            this._nefertiti.position.set(stageCenter[0], stageCenter[1] + landscapeOffset);

        }
    }

    private setFiretoFrame(slow:boolean):void {
        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.NEFERTITI_FLAME_APPEAR);
        (this._fire as any)._textures = GameResources.getTextures("fireOneCycle");
        this._fire.visible = true;
        this._fire.alpha = 1;
        this._fire.getAnimation(undefined, undefined, () => this.loopFireToFrame(slow));
    }

    private loopFireToFrame(slow:boolean):void {
        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.NEFERTITI_FLAME_LOOP, -1);
        (this._fire as any)._textures = GameResources.getTextures("fireLoop");
        this._fire.playLoop();
        this._fire.visible = true;
        this._fire.alpha = 1;

        if(slow) {
            this.slowDownReels();
        }
    }

    private syncReelsOnSpinStart():void {
        if(this._curseSymbol !== "W") {
            this.slowDownReels();
        }
        this.setFiretoFrame(false);
    }

    private createNefertiti():void {
        let nefertiti:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("curseOfnefertiti")[0]);

        const offset:number = 60;

        nefertiti.anchor.set(0.5);
        nefertiti.alpha = 0;

        this._bgOverlay = new PIXI.Graphics();
        this._bgOverlay.beginFill(0x000000, 0.85);
        this._bgOverlay.drawRect(this._gameConfigInstance.REEL_AREA_POS_X + offset, this._gameConfigInstance.REEL_AREA_POS_Y, this._gameConfigInstance.REEL_AREA_WIDTH - (2 * offset), this._gameConfigInstance.REEL_AREA_HEIGHT);
        this._bgOverlay.endFill();
        this._bgOverlay.visible = false;

        this._layer.addChild(this._bgOverlay);
        this._layer.addChild(nefertiti);

        this._nefertiti = nefertiti;
    }

    private slowDownReels():void {
        let middleReels:number[] = [3, 4, 5, 6, 7, 8, 9, 10, 11];

        let reelController:TombOfNefertitiReelController;

        for(let i = 0; i < middleReels.length; i++) {
            reelController = <TombOfNefertitiReelController>Reels.getReel(middleReels[i])!;

            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {
                reelSetName : "CURSE_REELSET",
                reelSetPosition : 5,
                reelId : middleReels[i]
            }));

            reelController.setSyncReelSpeed(middleReels[i], 0.3, 3);
        }
    }

    private stopFire(data:IReelStoppedData):void {
        const lastReelId:number = this._gameConfigInstance.REELS_NUM - 1,
            duration:number = 0.5,
            reelIdToCheck:number = 11; // it is the last reel id in the middle reels

        if(data.reelId === reelIdToCheck) {
            if(this._fire.alpha > 0 && !this._endPlayed) {
                TweenLite.to(this._fire, duration, {
                    alpha : 0
                });

                this._endPlayed = true;

                SlotGame.sound.stopEffect(TombOfNefertitiSoundConfig.instance.NEFERTITI_FLAME_LOOP);
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.NEFERTITI_FLAME_EXTINGUISH);
                for(let i:number = 0; i < this._fireEnd.length; ++i) {
                    this._fireEnd[i].getAnimationAutoShowHide(true, true);
                }

                EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.START_GAME_SHAKING_REEL_AREA_FS_MODE));
                TweenLite.to(() => {}, 0.5, {
                    onComplete : () => {
                        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.STOP_GAME_SHAKING));
                    }
                });
            }
        }

        if(data.reelId === lastReelId) {
            this._fire.stopLoop();
            this._fire.visible = false;
            this._fire.alpha = 0;
        }
    }
}